document.addEventListener('DOMContentLoaded', function () {
  const isMobile = window.innerWidth <= 768 || /Mobi|Android|iPhone/i.test(navigator.userAgent);

  const desktopDivList = document.getElementsByClassName('desktop_drawer');

  // Set mobile var
  for (let i = 0; i < desktopDivList.length; i++) {
    const desktopDiv = desktopDivList[i];
    
    if (isMobile) {
      desktopDiv.style.display = 'none';
    } else {
      desktopDiv.style.display = 'flex';
    }
  }
});